import Api from '../Api';

export type EvaluatedFeatureFlags = Record<string, boolean | string>;

export function fetchEvaluatedFeatureFlags(keys: string[]): Promise<EvaluatedFeatureFlags> {
    // Only the flags the client actually uses are requested; the backend returns nothing else,
    // so backend-only / admin-only flags are never disclosed to signed-in users.
    return new Api().get('/views/feature-flags/evaluated', { keys });
}
